import { buildHead } from "@/lib/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/buyer/orders/$id")({
  head: () =>
    buildHead({
      title: "Order Tracking | LohaLink",
      description: "Track your LohaLink order stage, transit pings and delivery proof.",
      canonical: "/buyer/orders",
      noindex: true,
    }),
  component: lazyRouteComponent(() => import("@/pages/OrderTracking")),
});
